var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06011 3.99986L7.36011 1.69986C7.65011 1.40986 7.65011 0.929863 7.36011 0.639863C7.07011 0.349863 6.59011 0.349863 6.30011 0.639863L4.00011 2.93986L1.70011 0.639863C1.41011 0.349863 0.930107 0.349863 0.640107 0.639863C0.350107 0.929863 0.350107 1.40986 0.640107 1.69986L2.94011 3.99986L0.640107 6.29986C0.350107 6.58986 0.350107 7.06986 0.640107 7.35986C0.790107 7.50986 0.980107 7.57986 1.17011 7.57986C1.36011 7.57986 1.55011 7.50986 1.70011 7.35986L4.00011 5.05986L6.30011 7.35986C6.45011 7.50986 6.64011 7.57986 6.83011 7.57986C7.02011 7.57986 7.21011 7.50986 7.36011 7.35986C7.65011 7.06986 7.65011 6.58986 7.36011 6.29986L5.06011 3.99986Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRounded);
export default __webpack_public_path__ + "static/media/closeRounded.2433b488040210b6ac0b0c4ee137d2da.svg";
export { ForwardRef as ReactComponent };